export const COMPANY_URL = '/company/';
export const CAR_TEMPLATE_URL = '/carTemplate/';
export const NEW_CAR_TEMPLATE_URL = 'add';

export const APPROVAL_STATUS = {
  PENDING: 'PENDING',
  PENDING_IMAGE_UPDATE: 'PENDING_IMAGE_UPDATE',
  PENDING_IMAGE_VALIDATION: 'PENDING_IMAGE_VALIDATION',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
}




// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/constants/car-template-constants.ts